<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :isLimit="false">
      <template slot="self-config">
        <el-form-item label="展示方式">
          <el-radio-group v-model="form.btn_show_type">
            <el-radio :label="10">按钮形式</el-radio>
            <el-radio :label="20">表格形式</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="嵌入功能点">
          <el-table
            :data="form.deals"
            style="width:800px">
            <el-table-column
              label="功能点"
              width="200">
              <template scope="scope">
                <el-select v-model="scope.row.id">
                  <el-option 
                    v-for="option in deals"
                    :label="option.name"
                    :value="option.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="按钮颜色"
              width="200">
              <template scope="scope">
                <el-select v-model="scope.row.btn_color">
                  <el-option 
                    v-for="option in btnColors"
                    :label="option.name"
                    :value="option.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="字体颜色"
              width="200">
              <template scope="scope">
                <el-select v-model="scope.row.font_color">
                  <el-option 
                    v-for="option in fontColors"
                    :label="option.name"
                    :value="option.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template scope="scope">
                <div class="p-t-10 p-b-10">
                  <span>
                    <el-button size="small" type="primary" @click="sortUp(scope.$index)" :disabled="scope.$index == 0">上移</el-button>
                  </span>
                  <span>
                    <el-button size="small" type="primary" @click="sortDown(scope.$index)" :disabled="scope.$index == form.deals.length - 1">下移</el-button>
                  </span>
                  <span>
                    <el-button size="small" @click="deleteDeal(scope.$index)">删除</el-button>
                  </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="m-t-10 tx-c" style="width:800px">
            <el-button type="primary" @click="addDeal">添加一个</el-button>
          </div>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import cmsConfig from '../../../../config/cmsConfig'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          btn_show_type: 10,  // 按钮展示形式
          deals: [] // 绑定操作
        },
        dealModel: {
          id: '',
          btn_color: '',
          font_color: ''
        },
        fontColors: [
          { id: '#ffffff', name: '白色' },
          { id: '#000000', name: '黑色' }
        ],
        btnColors: [
          { id: '#36a9fe', name: '蓝色' },
          { id: '#0ec233', name: '绿色' },
          { id: '#ff4949', name: '红色' }
        ],
        deals: [] // 操作数组
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              this.form.deals = res.data.config.deals
              this.form.btn_show_type = res.data.config.btn_show_type
            }
            this.modelId = res.data.model_id
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      async getDeals(id) {
        let postData = {
          params: {
            content_id: id
          }
        }
        let res = await this.apiGet('cms/deals', postData)
        let data = this.promiseHandler(data, res)
        let rowDeals = []
        _(data).forEach((res) => {
          if (this.isRowDeal(res.type)) {
            rowDeals.push(res)
          }
        })
        return rowDeals
      },
      addDeal() {
        this.form.deals.push(_.cloneDeep(this.dealModel))
      },
      deleteDeal(index) {
        this.form.deals.splice(index)
      },
      sortUp(index) { // 上移
        let temp = this.form.deals[index]
        this.form.deals.splice(index, 1)
        this.form.deals.splice(index - 1, 0, temp)
      },
      sortDown(index) { // 下移
        let temp = this.form.deals[index]
        this.form.deals.splice(index, 1)
        this.form.deals.splice(index + 1, 0, temp)
      },
      isRowDeal(type) { // 是行内操作
        return type == this.OPERATION_ADD ||
               type == this.OPERATION_EDIT ||
               type == this.OPERATION_DETAIL ||
               type == this.OPERATION_DELETE ||
               type == this.OPERATION_STATUS ||
               type == this.OPERATION_DOWNLOAD ||
               type == this.OPERATION_MESSAGE ||
               type == this.OPERATION_EXEC ||
               type == this.OPERATION_IFRAME ||
               type == this.OPERATION_EXPORTWORD ||
               type == this.OPERATION_MULTI_ADD ||
               type == this.OPERATION_EMAIL
      }
    },
    async created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.deals = await this.getDeals(this.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, cmsConfig, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// dealGroupConfig.vue?f9a37e6c